import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const getCashIns = async ({ ...query }) => {
  const res = await Get(`${ApiPath.GetCashIns}`, query);
  return res.data;
};

export const createManualCashIn = async ({ ...query }) => {
  const res = await Post(`${ApiPath.ManualCashIn}`, query);
  return res.data;
};

export const batchManualCashIn = async ({ ...query }) => {
  const res = await Post(`${ApiPath.ManualCashIn}/batch`, query);
  return res.data;
};

export const voidCashIn = async ({ ...body }) => {
  const res = await Post(`ms-fleet/cashin/void`, body);
  return res.data;
};

export const updateCashInRemarks = async ({ id, ...body }) => {
  const res = await Put(`${ApiPath.GetCashIns}/${id}/remarks`, body);
  return res.data;
};